<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('buyVideo.nickname')" prop="nickname">
                <a-input v-model="queryParam.nickname" :placeholder="$t('buyVideo.inputNickname')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('buyVideo.serialNumber')" prop="serialNumber">
                <a-input-number :min="1" style="width: 100%;" v-model="queryParam.serialNumber" :placeholder="$t('buyVideo.inputSerialNumber')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('buyVideo.videoName')" prop="videoId">
                <a-tree-select
                  v-model="queryParam.videoId"
                  show-search
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :placeholder="$t('buyVideo.selectVideo')"
                  allow-clear
                  tree-default-expand-all
                  showSearch
                  treeNodeFilterProp="title"
                >
                  <a-tree-select-node :value="item.id" :key="item.id" :title="item.videoNameIn" v-for="(item,index) in listAll">
                  </a-tree-select-node>
                </a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations" style="display: flex; justify-content: flex-end;">
        <table-setting
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 详情 -->
      <detail-form ref="detailForm" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: true }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <!-- 操作列：详情 -->
        <span slot="operation" slot-scope="text, record">
           <!-- v-hasPermi="['user:buy/video:edit']" -->
           <a-divider type="vertical" />
          <!-- v-hasPermi="['user:buy/video:edit']" -->
          <a @click="$refs.detailForm.handleDetail(record)">
            <a-icon type="eye" />{{ $t('buyVideo.detail') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBuyVideo } from '@/api/user/buyVideo'
import CreateForm from './modules/CreateForm'
import DetailForm from './modules/DetailForm'
import { tableMixin } from '@/store/table-mixin'
import { listVideo } from '@/api/video/video'

export default {
  name: 'BuyVideo',
  components: {
    CreateForm,
    DetailForm
  },
  mixins: [tableMixin],
  data () {
    return {
      // 用户购买剧集记录列表
      list: [],
      // 表格加载状态
      loading: false,
      // 数据总数
      total: 0,
      // 查询参数
      queryParam: {
        nickname: undefined,
        serialNumber: undefined,
        videoId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      // 所有短剧列表（用于下拉选择）
      listAll: []
    }
  },
  computed: {
    // 表格列配置
    columns() {
      return [
        {
          title: this.$t('table.index'),
          dataIndex: 'index',
          customRender: (text, record, index) => index + 1,
          width: '10%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: this.$t('buyVideo.userNickname'),
          dataIndex: 'nickname',
          width: '10%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: this.$t('buyVideo.videoName'),
          dataIndex: 'videoName',
          width: '10%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: this.$t('buyVideo.orderNo'),
          dataIndex: 'orderNo',
          width: '20%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: this.$t('buyVideo.serialNumber'),
          dataIndex: 'serialNumber',
          width: '10%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: this.$t('buyVideo.type'),
          dataIndex: 'type',
          width: '10%',
          ellipsis: false,
          align: 'center',
          customRender: (t) => {
            const typeMap = {
              0: this.$t('buyVideo.free'),
              1: this.$t('buyVideo.coin'),
              2: this.$t('buyVideo.coin'),
              3: this.$t('buyVideo.watchAd')
            }
            return typeMap[t] || '-'
          }
        },
        {
          title: this.$t('buyVideo.price'),
          dataIndex: 'price',
          width: '10%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: this.$t('table.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: '20%',
          ellipsis: false,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: 80,
          scopedSlots: { customRender: 'operation' },
          ellipsis: false,
          align: 'center'
        }
      ]
    }
  },
  created () {
    // 初始化：获取购买记录列表和短剧列表
    this.getList()
    this.getVideoList()
  },
  methods: {
    /**
     * 获取所有短剧列表（用于下拉选择）
     */
    getVideoList() {
      listVideo().then(res => {
        this.listAll = res.data
      })
    },
    /**
     * 查询用户购买剧集记录列表
     */
    getList () {
      this.loading = true
      pageBuyVideo(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = Number(response.data.total)
        this.loading = false
      })
    },
    /**
     * 搜索按钮操作
     */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /**
     * 重置按钮操作
     */
    resetQuery () {
      this.queryParam = {
        nickname: undefined,
        serialNumber: undefined,
        videoId: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    /**
     * 分页改变事件
     * @param {number} current - 当前页码
     * @param {number} pageSize - 每页条数
     */
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/table-responsive.less';
</style>
